

















































import Vue from 'vue';
import Component from 'vue-class-component';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import {Prop} from 'vue-property-decorator';

export interface DynamicDocumentFontConfiguration {
  bold: boolean;
  italic: boolean;
  fontSize: number;
  colorHex: string;
}

@Component({
  name: 'dynamic-document-font-configuration-template',
  components: {AmetrasNumberFieldTemplate, AmetrasHexColorPickerTemplate}
})
export default class DynamicDocumentFontConfigurationTemplate extends Vue {

  @Prop() bold!: boolean;
  @Prop() italic!: boolean;
  @Prop() fontSize!: number;
  @Prop() colorHex!: string;

}
